







import SelectBox from '@/views/atoms/SelectBox.vue'
import Global from '@/common/global.js'

export default
  name: 'StatusBox'

  components: {
    SelectBox
    
  }

  data: () ->
    showStatusList: Global.showStatus(),
    status: '',

  props:
    name:
      type: String
      default: ''
    listData:
      type: Array
      default: []
    defaultValue: 
      type: String
      default: ''
    index:
      type: Number
      default: 0
    id:
      type: String
      default: ''

  watch: {
    defaultValue: (v) ->
      for row, index in @showStatusList
        if row.id == v
          @status = row.name
  }

  created: () ->
    for row, index in @showStatusList
      if row.id == @defaultValue
        @status = row.name

  methods: {
    change: (e) ->
      @$emit('change', e, @index, Number(@id))

    click: (e) ->
      for row, index in @showStatusList
        if row.id == @defaultValue
          @status = row.name
  }

